import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';

const DETAIL_PATH = `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.configImpact}/detail`;
const ANALYZE_PATH = `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.configImpact}/analyze`;

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = {} } = params;

	switch (action.id) {
		case 'viewDetail':
			return () => {
				history.push(`${DETAIL_PATH}/${encodeURIComponent(rowData.keyName)}`);
			};
		case 'analyze':
			return () => {
				history.push(`${ANALYZE_PATH}?key=${encodeURIComponent(rowData.keyName)}`);
			};
		default:
			return () => {};
	}
};
